import {
	useBlockProps,
	InspectorControls,
	PanelColorSettings,
} from "@wordpress/block-editor";

import { __ } from "@wordpress/i18n";

import "./style.scss";

export default function Edit({ attributes, setAttributes }) {
	const {
		lightBg,
		lightText,
		lightLink,
		lightIcon,
		darkBg,
		darkText,
		darkLink,
		darkIcon,
	} = attributes;

	const moon =
		'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-moon-fill" viewBox="0 0 16 16"><path d="M6 .278a.77.77 0 0 1 .08.858 7.2 7.2 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277q.792-.001 1.533-.16a.79.79 0 0 1 .81.316.73.73 0 0 1-.031.893A8.35 8.35 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.75.75 0 0 1 6 .278"/></svg>';

	const blockProps = useBlockProps({
		className: "swift-fse-blocks-toggle",
		style: {
			backgroundColor: "#eee",
			padding: "0.5rem",
			borderRadius: "50%",
			color: lightIcon, // Preview with light mode icon color
		},
	});

	return (
		<>
			<InspectorControls>
				<PanelColorSettings
					title={__("Light Mode Colors", "swift-fse-blocks")}
					initialOpen={true}
					colorSettings={[
						{
							value: lightBg,
							onChange: (color) => setAttributes({ lightBg: color }),
							label: __("Background", "swift-fse-blocks"),
						},
						{
							value: lightText,
							onChange: (color) => setAttributes({ lightText: color }),
							label: __("Text", "swift-fse-blocks"),
						},
						{
							value: lightLink,
							onChange: (color) => setAttributes({ lightLink: color }),
							label: __("Links", "swift-fse-blocks"),
						},
						{
							value: lightIcon,
							onChange: (color) => setAttributes({ lightIcon: color }),
							label: __("Icon", "swift-fse-blocks"),
						},
					]}
				/>

				<PanelColorSettings
					title={__("Dark Mode Colors", "swift-fse-blocks")}
					initialOpen={false}
					colorSettings={[
						{
							value: darkBg,
							onChange: (color) => setAttributes({ darkBg: color }),
							label: __("Background", "swift-fse-blocks"),
						},
						{
							value: darkText,
							onChange: (color) => setAttributes({ darkText: color }),
							label: __("Text", "swift-fse-blocks"),
						},
						{
							value: darkLink,
							onChange: (color) => setAttributes({ darkLink: color }),
							label: __("Links", "swift-fse-blocks"),
						},
						{
							value: darkIcon,
							onChange: (color) => setAttributes({ darkIcon: color }),
							label: __("Icon", "swift-fse-blocks"),
						},
					]}
				/>
			</InspectorControls>

			<div
				className="swiftpress-toggle"
				{...blockProps}
				dangerouslySetInnerHTML={{ __html: moon }}
			/>
		</>
	);
}
